import { useMount } from '@tiger/hooks';
import Icon from '@tiger/icons';
import { FC, useState } from 'react';
import AgreementContent from 'components/AgreementList/AgreementContent';
import Button from 'components/base/Button';
import Modal, { ModalHandler } from 'components/base/Modal';
import Collapse from 'components/Collapse';
import type { EventParams } from 'types/common';
import { isDev } from 'utils/API';
import { useTrack } from 'utils/track';
import styles from './style.scss';

const linkCode1 = isDev ? 'USA-Marsco-0015-test' : 'USA-Marsco-0015';
const linkCode2 = isDev ? 'USA-Marsco-0016-test' : 'USA-Marsco-0016';

const agreementList: Array<{ title: string; linkCode: string }> = [
    {
        title: __('Master Securities Lending Agreement'),
        linkCode: linkCode1
    },
    {
        title: __('Fully Paid Securities Lending Program Disclosure'),
        linkCode: linkCode2
    }
];

interface AgreementModalProps extends ModalHandler {
    exposureEventParams?: EventParams;
    enrollEventParams?: EventParams;
    cancelEventParams?: EventParams;
}

const AgreementModal: FC<AgreementModalProps> = ({
    close,
    dismiss,
    exposureEventParams,
    enrollEventParams,
    cancelEventParams
}) => {
    const [curIndex, setCurIndex] = useState<number>(0);
    const { trackEvent } = useTrack();

    useMount(() => {
        if (exposureEventParams) {
            trackEvent(exposureEventParams);
        }
    });

    return (
        <div className={styles.root}>
            <div className="d-flex justify-content-between mb-3">
                <h4 className="mb-0 fs-3">{__('Agreements')}</h4>
                <Icon
                    type="close"
                    fill="#2c2e3b"
                    width={16}
                    height={16}
                    onClick={() => {
                        if (cancelEventParams) {
                            trackEvent(cancelEventParams);
                        }

                        dismiss(false);
                    }}
                />
            </div>
            {agreementList.map((item, index) => (
                <Collapse
                    key={index}
                    expanded={curIndex === index}
                    onChange={(isOpen: boolean) => {
                        // 当前项开启或关闭时打开另一项
                        setCurIndex(isOpen ? index : curIndex - 1 >= 0 ? curIndex - 1 : curIndex + 1);
                    }}
                    headerClassName={styles.collapseHeader}
                    title={item.title}>
                    <AgreementContent className={styles.agreement} linkCode={item.linkCode} />
                </Collapse>
            ))}
            <div className={styles.btnContainer}>
                <Button
                    className={styles.btn}
                    type="primary"
                    size="lg"
                    onClick={() => {
                        if (enrollEventParams) {
                            trackEvent(enrollEventParams);
                        }

                        close(true);
                    }}>
                    {__('Enroll')}
                </Button>
            </div>
        </div>
    );
};

export default AgreementModal;

export const openAgreementModal = (props?: Omit<AgreementModalProps, keyof ModalHandler>) => {
    return Modal.openSlideModal({
        component: modalHandlerProps => <AgreementModal {...props} {...modalHandlerProps} />,
        backdrop: 'static',
        responsive: true
    }).result.catch(() => {});
};
